<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogPostComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogPostComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             @click="openPopupChoose"/>
      </options-element-bar>

      <simple-theme :article="article" :show="internal_config.show" :colors="internal_config.colors" :styles="internal_config.styles" />

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import Resources from './Resources.vue';
import _ from 'lodash';
import SimpleTheme from './themes/Simple';

export default {
  name: 'BlogPostComponent',
  props: ['config', 'id'],
  components: { OptionsElementBar, Resources, SimpleTheme },
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = _.merge(this.internal_config, config);
    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `width: ${this.internal_config.width};
               height:  auto !important;
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    },
    callBackSettings(data) {
      this.internal_config.show = _.clone(data);
    },
    openPopupChoose() {
      this.$root.$emit('openBlogSettingsModal', _.clone(this.internal_config), this.$options.name, this.callBackSettings);
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$refs.resourcesData.setValuesData(this);

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id === id) {
        this.config = obj;
        this.config.thumbnail = 'https://e7.pngegg.com/pngimages/8/36/png-clipart-man-black-illustration-computer-icons-google-account-user-profile-iconfinder-com-icons-profile-account-profile-thumbnail.png'
        this.internal_config = obj;
      }
    });
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  }
};
</script>

<style>

  [element="BlogPostComponent"],
  [element="BlogPostComponent"] .vdr {
    height: auto !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Post/Post.vue